import styled from "@emotion/styled";
import { ReactNode } from "react";

interface IconChipProps {
  icon: ReactNode;
  bg: string;
  color: string;
}

/** ชิปไอคอนพาสเทลมุมขวาบนของการ์ด KPI */
const IconChip = ({ icon, bg, color }: IconChipProps) => (
  <Chip bg={bg} color={color}>
    {icon}
  </Chip>
);

export default IconChip;

const Chip = styled.div<{ bg: string; color: string }>`
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  background: ${(p) => p.bg};
  color: ${(p) => p.color};
  font-size: 16px;
`;
